import {} from '@safe-global/safe-apps-provider';
import {} from '@safe-global/safe-apps-sdk';
import { ProviderNotFoundError, createConnector, normalizeChainId, } from '@wagmi/core';
import { getAddress } from 'viem';
safe.type = 'safe';
export function safe(parameters = {}) {
    const { shimDisconnect = false } = parameters;
    let provider_;
    return createConnector((config) => ({
        id: 'safe',
        name: 'Safe',
        type: safe.type,
        async connect() {
            const provider = await this.getProvider();
            if (!provider)
                throw new ProviderNotFoundError();
            const accounts = await this.getAccounts();
            const chainId = await this.getChainId();
            provider.on('disconnect', this.onDisconnect.bind(this));
            // Remove disconnected shim if it exists
            if (shimDisconnect)
                await config.storage?.removeItem('safe.disconnected');
            return { accounts, chainId };
        },
        async disconnect() {
            const provider = await this.getProvider();
            if (!provider)
                throw new ProviderNotFoundError();
            provider.removeListener('disconnect', this.onDisconnect.bind(this));
            // Add shim signalling connector is disconnected
            if (shimDisconnect)
                await config.storage?.setItem('safe.disconnected', true);
        },
        async getAccounts() {
            const provider = await this.getProvider();
            if (!provider)
                throw new ProviderNotFoundError();
            return (await provider.request({ method: 'eth_accounts' })).map(getAddress);
        },
        async getProvider() {
            // Only allowed in iframe context
            const isIframe = typeof window !== 'undefined' && window?.parent !== window;
            if (!isIframe)
                return;
            if (!provider_) {
                const { default: SafeAppsSDK } = await import('@safe-global/safe-apps-sdk');
                let SDK;
                if (typeof SafeAppsSDK !== 'function' &&
                    typeof SafeAppsSDK.default === 'function')
                    SDK = SafeAppsSDK.default;
                else
                    SDK = SafeAppsSDK;
                const sdk = new SDK(parameters);
                const safe = await sdk.safe.getInfo();
                if (!safe)
                    throw new Error('Could not load Safe information');
                const { SafeAppProvider } = await import('@safe-global/safe-apps-provider');
                provider_ = new SafeAppProvider(safe, sdk);
            }
            return provider_;
        },
        async getChainId() {
            const provider = await this.getProvider();
            if (!provider)
                throw new ProviderNotFoundError();
            return normalizeChainId(provider.chainId);
        },
        async isAuthorized() {
            try {
                const isDisconnected = shimDisconnect &&
                    // If shim exists in storage, connector is disconnected
                    (await config.storage?.getItem('safe.disconnected'));
                if (isDisconnected)
                    return false;
                const accounts = await this.getAccounts();
                return !!accounts.length;
            }
            catch {
                return false;
            }
        },
        onAccountsChanged() {
            // Not relevant for Safe because changing account requires app reload.
        },
        onChainChanged() {
            // Not relevant for Safe because Safe smart contract wallets only exist on single chain.
        },
        onDisconnect() {
            config.emitter.emit('disconnect');
        },
    }));
}
//# sourceMappingURL=safe.js.map